module.exports = __webpack_public_path__ + "img/specifi_logo_blue.88526068.svg";